/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// ES module-style import
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
	apiKey: 'ccc9f84809668a8a77bdc879d6afc7f7',
	plugins: [new BugsnagPluginReact()]
})
// You can delete this file if you're not using it
export const onServiceWorkerUpdateReady = () => {
	const answer = window.confirm(
		`This application has been updated. ` +
		`Reload to display the latest version?`
	);
	if (answer === true) {
		window.location.reload()
	}
};
export const onInitialClientRender = () => {
	setTimeout(function() {
		document.getElementById("___loader").style.display = "none"
	}, 100)
}
